<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/account")
            i.fa.fa-users
            span.ml-1 {{ $t("title.accounts") }}
        b-breadcrumb-item
          router-link(to="/account/newAccount")
            i.fa.fa-user-plus
            span.ml-1 {{ $t("title.new_account") }}
  .row
    .col-md-7.col-12
      .card.mb-2
        .card-header.p-2.bg-gradient-light
          i.fa.fa-key.me-1
          span {{ $t('ui.account') }}
        .card-body.pb-1.pt-2.px-2
          .row
            .col-7
              b-form-group(:label="$t('ui.account_id')")
                DebounceInput(
                  size="sm"
                  autofocus
                  type="text"
                  :dirty="$v.account_id.$dirty"
                  :error="$v.account_id.$error"
                  v-model.trim.lazy="$v.account_id.$model"
                  :maxLength="$v.account_id.$params.maxLength.max"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
              b-form-group(:label="$t('ui.password')")
                DebounceInput(
                  size="sm"
                  type="text"
                  :dirty="$v.password.$dirty"
                  :error="$v.password.$error"
                  v-model.trim.lazy="$v.password.$model"
                  :maxLength="$v.password.$params.maxLength.max"
                  :disabled="loading"
                  autocomplete="section-red password"
                )
                ValidateResult(:value="$v.password" :name="$t('ui.password')")
              b-form-group(:label="$t('ui.confirm_password')")
                DebounceInput(
                  size="sm"
                  type="text"
                  :dirty="$v.confirm_password.$dirty"
                  :error="$v.confirm_password.$error"
                  v-model.trim.lazy="$v.confirm_password.$model"
                  :disabled="loading"
                  autocomplete="section-red confirm-password"
                )
                ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')")
            .col-5
              b-form-group(:label="$t('ui.portion')")
                DebounceInput(
                  size="sm"
                  type="number"
                  :dirty="$v.portion.$dirty"
                  :error="$v.portion.$error"
                  v-model.trim.lazy="$v.portion.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.portion" :name="$t('ui.portion')")
              b-form-group(:label="$t('ui.currency')")
                .form-control.form-control-sm.disabled
                  i.flag-icon.flag-icon-mn.mr-1
                  span {{ currency }}
    .col-md-5.col-12
      .card.mb-2
        .card-header.p-2.bg-gradient-light
          i.fa.fa-address-card.me-1
          span {{ $t('ui.profile') }}
        .card-body.pb-1.pt-2.px-2
          b-form-group(:label="$t('ui.full_name')")
            DebounceInput(
              size="sm"
              type="text"
              :dirty="$v.full_name.$dirty"
              :error="$v.full_name.$error"
              v-model.trim.lazy="$v.full_name.$model"
              :maxLength="$v.full_name.$params.maxLength.max"
              :disabled="loading"
              autocomplete="new-password"
            )
            ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
          b-form-group(:label="$t('ui.contact_phone')")
            DebounceInput(
              size="sm"
              type="text"
              :placeholder="$t('message.phoneFormat')"
              :dirty="$v.contact_phone.$dirty"
              :error="$v.contact_phone.$error"
              v-model.trim.lazy="$v.contact_phone.$model"
              :maxLength="$v.contact_phone.$params.maxLength.max"
              :disabled="loading"
            )
            ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
          b-form-group(:label="$t('ui.contact_email')")
            DebounceInput(
              size="sm"
              type="text"
              :dirty="$v.contact_email.$dirty"
              :error="$v.contact_email.$error"
              v-model.trim.lazy="$v.contact_email.$model"
              :maxLength="$v.contact_email.$params.maxLength.max"
              :disabled="loading"
            )
            ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
    .col-md-12.col-12
      .card.mb-2
        .card-header.p-2.bg-gradient-light
          i.fa.fa-filter.me-1
          span {{ $t('ui.sportsbook') }}
        .card-body.pb-2.pt-2.px-2
          .table-responsive.mb-0
            table.table.table-b-0.m-0(style="min-width: 500px;")
              thead
                tr
                  th.p-1(style="width: 60px;") {{ $t("ui.type") }}
                  th.p-1(style="width: 120px;") {{ $t("ui.minBet") }}
                  th.p-1 {{ $t("ui.maxBet") }}
                  th.p-1 {{ $t("ui.maxPerMatch") }}
              tbody
                template(v-for="item in limits['SPORTSBOOK']")
                  tr.form-group(:key="item.sport_type")
                    td.p-1.align-middle
                      span.text-capitalize {{ item.sport_type }}
                    td.p-1.align-middle
                      input.form-control.form-control-sm.font-weight-bold.py-0.px-1(
                        type="number"
                        v-model="item.min_bet"
                        :min="min"
                        :max="max"
                        :class="{ 'border-danger' : item.min_bet_error }"
                        )
                    td.p-1.align-middle
                      input.form-control.form-control-sm.font-weight-bold.py-0.px-1(
                        type="number"
                        v-model="item.max_bet"
                        :min="min"
                        :max="max"
                        :class="{ 'border-danger' : item.max_bet_error }"
                        )
                    td.p-1.align-middle
                      input.form-control.form-control-sm.font-weight-bold.py-0.px-1(
                        type="number"
                        v-model="item.max_per_match"
                        :min="item.max_bet"
                        :max="mpm"
                        :class="{ 'border-danger' : item.max_per_match_error }"
                        )
                  tr
                    td.py-0.px-1
                    td.py-0.px-1
                      .d-block.text-xxs.text-right.text-grey ({{ $t("ui.min")}}: {{ $numeral(min).format('0,0a') }})
                    td.py-0.px-1
                      .d-block.text-xxs.text-right.text-grey ({{ $t("ui.max")}}: {{ $numeral(max).format('0,0a') }})
                    td.py-0.px-1
                      .d-block.text-xxs.text-right.text-grey ({{ $t("ui.range")}}: {{ $numeral(item.max_bet).format('0,0a') }} - {{ $numeral(mpm).format('0,0a') }})
    .col-md-6.col-12
      .card.mb-2
        .card-header.p-2.bg-gradient-light
          i.fa.fa-filter.me-1
          span {{ $t('ui.livecasino') }}
        .card-body.px-3.pt-3.pb-2
          .row(v-if="limits['LIVECASINO']['bet_limits']" role="form")
            .col-lg-6.col-md-6.col-6(v-for="item, key in limits['LIVECASINO']['bet_limits']")
              .form-group.p-0.m-0.mb-2
                .form-check.form-switch.d-flex.align-items-center.justify-content-start
                  label.switch.switch-label.switch-info.mb-0
                    input(
                      type="checkbox"
                      class="switch-input"
                      v-model="limits['LIVECASINO']['bet_limits'][key]")
                    span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
                  b.form-check-label.text-info.m-0.ml-2.text-uppercase {{ $t("ui.package") }} {{ key }}
    .col-md-6.col-12
      .card.mb-2
        .card-header.p-2.bg-gradient-light
          i.fa.fa-filter.me-1
          span {{ $t('ui.lottery') }}
        .card-body.px-3.pt-3.pb-2
          .row(v-if="limits['LOTTERY']['bet_limits']" role="form")
            .col-lg-6.col-md-6.col-6(v-for="item, key in limits['LOTTERY']['bet_limits']")
              .form-group.p-0.m-0.mb-2
                .form-check.form-switch.d-flex.align-items-center.justify-content-start
                  label.switch.switch-label.switch-info.mb-0
                    input(
                      type="checkbox"
                      class="switch-input"
                      v-model="limits['LOTTERY']['bet_limits'][key]")
                    span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
                  b.form-check-label.text-info.m-0.ml-2.text-uppercase {{ $t("ui.package") }} {{ key }}
  .row
    .col
      b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  .row
    .col-12
      .d-flex.align-items-center.justify-content-end
        button.btn.btn-danger.btn-brand.btn-md(v-if="!loading" type="button" @click="submit")
          i.me-1
            b.fa.fa-save
          span {{ $t("ui.save") }}
        button.btn.btn-danger.btn-brand.btn-md(v-else type="button" :disabled="loading")
          i.me-1
            b.fa.fa-spinner.fa-spin
          span {{ $t("ui.save") }}

  #end-report.mt-3
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      item: {},
      account_id: "",
      password: "",
      confirm_password: "",
      full_name: "",
      contact_phone: "",
      contact_email: "",
      currency: "MNT",
      portion: 90,
      min: config.LIMIT.MIN,
      max: config.LIMIT.MAX,
      mpm: config.LIMIT.MPM,
      packages: config.LIMIT.PACKAGES,
      limits: {
        LIVECASINO: {
          provider_type: "LIVECASINO",
          package: config.LIMIT.PACKAGES,
          bet_limits: {
            A: true,
            B: true,
            C: true,
            D: true,
            E: true,
            F: true
          }
        },
        LOTTERY: {
          provider_type: "LOTTERY",
          package: config.LIMIT.PACKAGES,
          bet_limits: {
            A: true,
            B: true,
            C: true,
            D: true,
            E: true,
            F: true
          }
        },
        SPORTSBOOK: {
          BASEBALL: {
            provider_type: "SPORTSBOOK",
            sport_type: "BASEBALL",
            min_bet: 10,
            max_bet: 1000,
            max_per_match: 10000
          },
          BASKETBALL: {
            provider_type: "SPORTSBOOK",
            sport_type: "BASKETBALL",
            min_bet: 10,
            max_bet: 1000,
            max_per_match: 10000
          },
          ESPORTS: {
            provider_type: "SPORTSBOOK",
            sport_type: "ESPORTS",
            min_bet: 10,
            max_bet: 1000,
            max_per_match: 10000
          },
          OTHERS: {
            provider_type: "SPORTSBOOK",
            sport_type: "OTHERS",
            min_bet: 10,
            max_bet: 1000,
            max_per_match: 10000
          },
          PARLAY: {
            provider_type: "SPORTSBOOK",
            sport_type: "PARLAY",
            min_bet: 10,
            max_bet: 1000,
            max_per_match: 10000
          },
          SOCCER: {
            provider_type: "SPORTSBOOK",
            sport_type: "SOCCER",
            min_bet: 10,
            max_bet: 1000,
            max_per_match: 10000
          },
          TENNIS: {
            provider_type: "SPORTSBOOK",
            sport_type: "TENNIS",
            min_bet: 10,
            max_bet: 1000,
            max_per_match: 10000
          }
        }
      },
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      minLength: minLength(5),
      maxLength: maxLength(20)
    },
    password: {
      required,
      containAlphaNum,
      valid: function(value) {
        return this.$helpers.passwordFormat(value);
      },
      minLength: minLength(8),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs("password")
    },
    full_name: {
      maxLength: maxLength(50)
    },
    contact_phone: {
      required,
      integer,
      minLength: minLength(11),
      maxLength: maxLength(11)
    },
    contact_email: {
      email,
      minLength: minLength(1),
      maxLength: maxLength(50)
    },
    currency: {
      required
    },
    portion: {
      required,
      integer
    }
  },
  mounted() {
    this.$v.$reset();
  },
  methods: {
    checkBetLimit() {
      this.reset();
      if (this.limits == undefined) {
        return false;
      }
      if (this.limits["SPORTSBOOK"] == undefined) {
        return false;
      }

      var isError = true;
      for (var i in this.limits["SPORTSBOOK"]) {
        var j = this.limits["SPORTSBOOK"][i];
        if (j) {
          if (j.min_bet < this.min) {
            this.$set(j, "min_bet_error", true);
            isError = false;
          }
          if (j.max_bet < this.min) {
            this.$set(j, "max_bet_error", true);
            isError = false;
          }
          if (j.min_bet > this.max) {
            this.$set(j, "min_bet_error", true);
            isError = false;
          }
          if (j.max_bet > this.max) {
            this.$set(j, "max_bet_error", true);
            isError = false;
          }
          if (j.max_per_match < j.max_bet) {
            this.$set(j, "max_per_match_error", true);
            isError = false;
          }
          if (j.max_per_match > this.mpm) {
            this.$set(j, "max_per_match_error", true);
            isError = false;
          }
        }
      }

      return isError;
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    submit() {
      if (!this.checkBetLimit()) {
        return;
      }
      if (this.loading) return;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        var args = {
          session_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username,
          account_id: this.account_id,
          account_currency: this.currency,
          password: this.password,
          full_name: this.full_name,
          contact_phone: this.contact_phone,
          contact_email: this.contact_email,
          portion: this.portion
        };
        var b = [];
        for (var i in this.limits["LIVECASINO"]["bet_limits"]) {
          if (this.limits["LIVECASINO"]["bet_limits"][i]) {
            b.push(i);
          }
        }
        if (!b.includes("A")) {
          this.$helpers.showDialog(this.$t("ui.add_account"), this.$t("error.packageARequired"), "error");
          return;
        }
        args["bet_limit_packages_casino"] = b.join(",");
        b = [];
        for (var i in this.limits["LOTTERY"]["bet_limits"]) {
          if (this.limits["LOTTERY"]["bet_limits"][i]) {
            b.push(i);
          }
        }
        if (!b.includes("A")) {
          this.$helpers.showDialog(this.$t("ui.add_account"), this.$t("error.packageARequired"), "error");
          return;
        }
        args["bet_limit_packages_lottery"] = b.join(",");
        for (var i in this.limits["SPORTSBOOK"]) {
          var d = this.limits["SPORTSBOOK"][i];
          args[i.toLowerCase() + "_min_bet"] = d["min_bet"];
          args[i.toLowerCase() + "_max_bet"] = d["max_bet"];
          args[i.toLowerCase() + "_max_per_match"] = d["max_per_match"];
        }
        this.feedback.success = true;
        this.loading = true;

        xhr
          .doRequest(args, xhr.ACCOUNT.addAccount)
          .then(res => {
            this.loading = false;
            this.feedback.success = res.success;
            this.feedback.status = res.status;
            if (res.success == true) {
              this.$helpers.showDialog(this.$t("ui.add_account"), this.$t("message.success"), "success");
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          })
          .catch(res => {
            this.loading = false;
            if (res.status.toLowerCase() == "nochanges") {
            } else {
              this.feedback.success = false;
              this.feedback.status = res.status;
            }
          });
      }
    }
  }
};
</script>
